// extracted by mini-css-extract-plugin
export default {"titulo":"styles_titulo__gdO9+","titulo__registro":"styles_titulo__registro__lNkTF"};